/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../connect/v2/common/filters';
import '../../connect/v2/resources/error';
import './device_code';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "external": {
            "nested": {
              "SearchDeviceCodesRequest": {
                "fields": {
                  "query": {
                    "type": ".squareup.devicesettings.external.SearchDeviceCodesQuery",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "limit": {
                    "type": "int32",
                    "id": 3,
                    "rule": "optional"
                  },
                  "includePasswords": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  }
                }
              },
              "SearchDeviceCodesQuery": {
                "fields": {
                  "filter": {
                    "type": ".squareup.devicesettings.external.SearchDeviceCodesFilter",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "SearchDeviceCodesFilter": {
                "fields": {
                  "locationId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "productTypesFilter": {
                    "type": ".squareup.connect.v2.common.FilterValue",
                    "id": 2,
                    "rule": "optional"
                  },
                  "statusFilter": {
                    "type": ".squareup.connect.v2.common.FilterValue",
                    "id": 3,
                    "rule": "optional"
                  },
                  "locationIds": {
                    "type": "string",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "name": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "sortField": {
                    "type": ".squareup.devicesettings.external.SearchDeviceCodesFilter.SortField",
                    "id": 6,
                    "rule": "optional",
                    "options": {
                      "default": "CREATED_AT"
                    }
                  },
                  "sortDirection": {
                    "type": ".squareup.devicesettings.external.SearchDeviceCodesFilter.SortDirection",
                    "id": 7,
                    "rule": "optional",
                    "options": {
                      "default": "DESC"
                    }
                  }
                },
                "nested": {
                  "SortField": {
                    "values": {
                      "CREATED_AT": 0,
                      "DEVICE_CODE_NAME": 1
                    }
                  },
                  "SortDirection": {
                    "values": {
                      "DESC": 0,
                      "ASC": 1
                    }
                  }
                }
              },
              "SearchDeviceCodesResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "deviceCodes": {
                    "type": ".squareup.devicesettings.external.DeviceCode",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.external?.nested?.SearchDeviceCodesRequest && !$root.nested?.squareup?.nested?.devicesettings?.nested?.external?.nested?.SearchDeviceCodesQuery && !$root.nested?.squareup?.nested?.devicesettings?.nested?.external?.nested?.SearchDeviceCodesFilter && !$root.nested?.squareup?.nested?.devicesettings?.nested?.external?.nested?.SearchDeviceCodesFilter?.nested?.SortField && !$root.nested?.squareup?.nested?.devicesettings?.nested?.external?.nested?.SearchDeviceCodesFilter?.nested?.SortDirection && !$root.nested?.squareup?.nested?.devicesettings?.nested?.external?.nested?.SearchDeviceCodesResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE SearchDeviceCodesRequest @ squareup/devicesettings/external/device_code_search.proto at 18:1
 */
export const SearchDeviceCodesRequest = $root.lookupType('squareup.devicesettings.external.SearchDeviceCodesRequest');
fixType(SearchDeviceCodesRequest, {
  query: {
    required: true
  }
});
Builder.createAndAttachToType(SearchDeviceCodesRequest);
/**
 * SOURCE SearchDeviceCodesQuery @ squareup/devicesettings/external/device_code_search.proto at 29:1
 */
export const SearchDeviceCodesQuery = $root.lookupType('squareup.devicesettings.external.SearchDeviceCodesQuery');
fixType(SearchDeviceCodesQuery);
Builder.createAndAttachToType(SearchDeviceCodesQuery);
/**
 * SOURCE SearchDeviceCodesFilter @ squareup/devicesettings/external/device_code_search.proto at 33:1
 */
export const SearchDeviceCodesFilter = $root.lookupType('squareup.devicesettings.external.SearchDeviceCodesFilter');
fixType(SearchDeviceCodesFilter);
Builder.createAndAttachToType(SearchDeviceCodesFilter);
/**
 * SOURCE SortField @ squareup/devicesettings/external/device_code_search.proto at 72:3
 */
SearchDeviceCodesFilter.SortField = $root.lookupEnum('squareup.devicesettings.external.SearchDeviceCodesFilter.SortField').values;
/**
 * SOURCE SortDirection @ squareup/devicesettings/external/device_code_search.proto at 81:3
 */
SearchDeviceCodesFilter.SortDirection = $root.lookupEnum('squareup.devicesettings.external.SearchDeviceCodesFilter.SortDirection').values;
/**
 * SOURCE SearchDeviceCodesResponse @ squareup/devicesettings/external/device_code_search.proto at 87:1
 */
export const SearchDeviceCodesResponse = $root.lookupType('squareup.devicesettings.external.SearchDeviceCodesResponse');
fixType(SearchDeviceCodesResponse);
Builder.createAndAttachToType(SearchDeviceCodesResponse);